/* See it on nails: plays a product's studio clip inside its tile and opens the window with the steps.
   Section: sections/wf-demo-hero.liquid. Styles: assets/wf-demo.css. Plain script, no libraries.
   Exposes window.WfDemo = { init, destroy, initAll, instances }.

   A root is any element with data-wf-demo. Its data-wf-mode lists the behaviours, space separated:
     hover   a mouse resting on a tile plays its clip inside the frame (fine pointers only)
     modal   the chip opens the root's dialog, filled from the tile's template
   Inside the root:
     [data-wf-tile]               a tile. Gains data-wf-playing="hover" while its clip plays in the frame
     [data-wf-loop]               the muted clip in the frame; its file lives in data-mp4 (and data-webm) until first use
     [data-wf-open="<key>"]       the chip (a button, a sibling of the card so it never sits inside a link)
     template[data-wf-tpl="key"]  the window content for a tile
     [data-wf-dialog]             one dialog per root; [data-wf-dialog-content] inside receives the clone
     [data-wf-demo-video]         the clip inside the window
     [data-wf-url]                a link to the product, the fallback when the browser has no dialog
   Reduced motion: the class in data-wf-reduced-class (default wf-demo--reduced-motion), the media
   query, or Save-Data. Then nothing plays by itself; anything the shopper presses still plays.
   data-wf-force-touch on the root makes a desktop browser behave like a phone (used by the preview). */
(function (w, d) {
  'use strict';
  if (w.WfDemo) return;

  var mq = function (q) { return w.matchMedia ? w.matchMedia(q) : { matches: false }; };

  function Demo(root) {
    this.root = root;
    this.modes = {};
    var tokens = (root.getAttribute('data-wf-mode') || '').split(/\s+/);
    for (var i = 0; i < tokens.length; i++) { if (tokens[i]) this.modes[tokens[i]] = true; }
    this.reducedClass = root.getAttribute('data-wf-reduced-class') || 'wf-demo--reduced-motion';
    this.unbinders = [];
    this.timers = [];
    this.current = null;
    this.opener = null;
    this.dialog = root.querySelector('[data-wf-dialog]');
    this.fine = root.hasAttribute('data-wf-force-touch') ? { matches: false } : mq('(hover: hover) and (pointer: fine)');
    this.reduceQuery = mq('(prefers-reduced-motion: reduce)');
    this.dialogOk = !!(this.dialog && typeof this.dialog.showModal === 'function');
    this.bind();
  }
  var P = Demo.prototype;

  /* ---- helpers ---- */
  P.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts);
    this.unbinders.push(function () { el.removeEventListener(type, fn, opts); });
  };
  P.later = function (fn, ms) { var id = w.setTimeout(fn, ms); this.timers.push(id); return id; };
  P.all = function (sel, scope) { return Array.prototype.slice.call((scope || this.root).querySelectorAll(sel)); };
  P.reduced = function () {
    var conn = w.navigator && w.navigator.connection;
    return this.root.classList.contains(this.reducedClass) || this.reduceQuery.matches || !!(conn && conn.saveData);
  };

  /* ---- media: sources are attached on first use, so nothing downloads until a tile is used ---- */
  P.arm = function (video) {
    if (!video || video.getAttribute('data-wf-armed')) return video;
    var webm = video.getAttribute('data-webm');
    var mp4 = video.getAttribute('data-mp4');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    // MP4 first (hardware decoded everywhere); WebM only as a fallback for builds without H.264
    var order = video.getAttribute('data-prefer') === 'webm' ? [[webm, 'video/webm'], [mp4, 'video/mp4']] : [[mp4, 'video/mp4'], [webm, 'video/webm']];
    for (var i = 0; i < order.length; i++) {
      if (!order[i][0]) continue;
      var src = d.createElement('source');
      src.src = order[i][0];
      src.type = order[i][1];
      video.appendChild(src);
    }
    video.setAttribute('data-wf-armed', '1');
    video.load();
    return video;
  };
  P.play = function (video) {
    if (!video) return;
    this.arm(video);
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.then(function () { video.removeAttribute('data-wf-blocked'); })
       .catch(function () { video.setAttribute('data-wf-blocked', '1'); });
    }
  };
  P.pause = function (video) { if (video && !video.paused) video.pause(); };
  P.unload = function (video) {
    if (!video) return;
    this.pause(video);
    while (video.firstChild) video.removeChild(video.firstChild);
    video.removeAttribute('src');
    video.removeAttribute('data-wf-armed');
    try { video.load(); } catch (e) { /* older browsers */ }
  };
  P.loopOf = function (tile) { return tile.querySelector('[data-wf-loop]'); };

  /* ---- the clip in the frame ---- */
  P.startTile = function (tile, why) {
    var video = this.loopOf(tile);
    if (!video) return;
    if (this.current && this.current !== tile) this.stopTile(this.current);
    tile.setAttribute('data-wf-playing', why);
    this.play(video);
    this.current = tile;
  };
  P.stopTile = function (tile) {
    tile.removeAttribute('data-wf-playing');
    this.pause(this.loopOf(tile));
    if (this.current === tile) this.current = null;
  };
  P.bindHover = function (tile) {
    var self = this;
    var timer = null;
    this.on(tile, 'pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!self.fine.matches || self.reduced()) return;
      if (tile.getAttribute('data-wf-playing')) return;
      timer = self.later(function () {
        timer = null;
        if (tile.getAttribute('data-wf-playing')) return;
        self.startTile(tile, 'hover');
      }, 150);
    });
    this.on(tile, 'pointerleave', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (timer) { w.clearTimeout(timer); timer = null; }
      if (tile.getAttribute('data-wf-playing') === 'hover') self.stopTile(tile);
    });
  };
  P.bindChip = function (tile, chip) {
    var self = this;
    var key = chip.getAttribute('data-wf-open');
    this.on(chip, 'click', function (e) {
      e.preventDefault();
      if (self.modes.modal && self.dialogOk) { self.openDialog(key, chip); return; }
      var link = tile.querySelector('[data-wf-url]');
      if (link && link.href) w.location.href = link.href;
    });
  };

  /* ---- the window ---- */
  P.openDialog = function (key, opener) {
    var dlg = this.dialog;
    var tpl = this.root.querySelector('template[data-wf-tpl="' + key + '"]');
    if (!this.dialogOk || !tpl) {
      var tile = opener && opener.closest ? opener.closest('[data-wf-tile]') : null;
      var link = tile ? tile.querySelector('[data-wf-url]') : null;
      if (link && link.href) w.location.href = link.href;
      return;
    }
    var content = dlg.querySelector('[data-wf-dialog-content]');
    while (content.firstChild) content.removeChild(content.firstChild);
    content.appendChild(tpl.content.cloneNode(true));
    var title = content.querySelector('[data-wf-dialog-title]');
    if (title) { title.id = 'wf-demo-title-' + key; dlg.setAttribute('aria-labelledby', title.id); }
    this.opener = opener || null;
    this.pauseAll();
    if (dlg.open) dlg.close();
    dlg.showModal();
    d.documentElement.classList.add('wf-demo-lock');
    var inner = dlg.querySelector('.wf-demo__dialog-inner') || dlg;
    inner.scrollTop = 0;
    var video = content.querySelector('[data-wf-demo-video]');
    if (video) {
      this.arm(video);
      if (this.reduced()) { video.setAttribute('controls', ''); } else { this.play(video); }
    }
    var close = dlg.querySelector('[data-wf-close]');
    if (close) close.focus({ preventScroll: true });
  };
  P.closeDialog = function () { if (this.dialog && this.dialog.open) this.dialog.close(); };
  P.bindDialog = function () {
    var self = this;
    var dlg = this.dialog;
    if (!dlg) return;
    this.on(dlg, 'close', function () {
      d.documentElement.classList.remove('wf-demo-lock');
      var video = dlg.querySelector('[data-wf-demo-video]');
      if (video) self.unload(video);
      var content = dlg.querySelector('[data-wf-dialog-content]');
      while (content.firstChild) content.removeChild(content.firstChild);
      if (self.opener) { try { self.opener.focus({ preventScroll: true }); } catch (e) { /* gone */ } self.opener = null; }
    });
    // A click on the backdrop lands on the dialog element itself
    this.on(dlg, 'click', function (e) { if (e.target === dlg) self.closeDialog(); });
    var close = dlg.querySelector('[data-wf-close]');
    if (close) this.on(close, 'click', function () { self.closeDialog(); });
  };

  P.pauseAll = function () {
    var self = this;
    this.all('[data-wf-tile]').forEach(function (tile) {
      tile.removeAttribute('data-wf-playing');
      self.pause(self.loopOf(tile));
    });
    this.current = null;
  };

  /* ---- wiring ---- */
  P.bind = function () {
    var self = this;
    this.all('[data-wf-tile]').forEach(function (tile) {
      var chip = tile.querySelector('[data-wf-open]');
      if (self.modes.hover && self.loopOf(tile)) self.bindHover(tile);
      if (chip) self.bindChip(tile, chip);
    });
    if (this.modes.modal) this.bindDialog();
    this.on(d, 'visibilitychange', function () {
      if (d.hidden) {
        self.all('[data-wf-loop], [data-wf-demo-video]').forEach(function (v) { self.pause(v); });
      } else if (self.dialog && self.dialog.open) {
        var v = self.dialog.querySelector('[data-wf-demo-video]');
        if (v && !self.reduced()) self.play(v);
      }
    });
    this.on(w, 'pagehide', function () { self.closeDialog(); self.pauseAll(); });
  };
  P.destroy = function () {
    this.closeDialog();
    this.pauseAll();
    this.unbinders.forEach(function (fn) { fn(); });
    this.unbinders = [];
    this.timers.forEach(function (id) { w.clearTimeout(id); });
    this.timers = [];
    var self = this;
    this.all('[data-wf-loop], [data-wf-demo-video]').forEach(function (v) { self.unload(v); });
    d.documentElement.classList.remove('wf-demo-lock');
  };

  /* ---- public API and boot (also on the theme editor's section events) ---- */
  var instances = [];
  function init(root) {
    if (!root || root.__wfDemo) return root && root.__wfDemo;
    var inst = new Demo(root);
    root.__wfDemo = inst;
    instances.push(inst);
    return inst;
  }
  function destroy(root) {
    var inst = root && root.__wfDemo;
    if (!inst) return;
    inst.destroy();
    delete root.__wfDemo;
    var i = instances.indexOf(inst);
    if (i !== -1) instances.splice(i, 1);
  }
  function initAll(scope) {
    Array.prototype.slice.call((scope || d).querySelectorAll('[data-wf-demo]')).forEach(init);
  }
  w.WfDemo = { init: init, destroy: destroy, initAll: initAll, instances: instances };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  d.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-wf-demo]')).forEach(destroy);
  });
})(window, document);
